/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      route — empty placeholder route for the use-voucher URL;
 *              template-only, no route-level logic
 *   extends:   Route
 *   template:  none
 *   model:     - (none defined; default Route#model())
 *   key:       - (empty class body)
 *   uses:      -
 *   siblings:  controllers/use-voucher.js, templates/use-voucher.hbs
 *   tests:     none
 */
import Route from '@ember/routing/route';

export default class UseVoucherRoute extends Route {}
